var map = {
	"./redcrm/locales/en_redcrm.json": "b74f",
	"./redcrm/locales/ja_redcrm.json": "6b87",
	"./redcrm/locales/ko_redcrm.json": "03f4",
	"./redsurvey/locales/en_redsurvey.json": "fa8e",
	"./redsurvey/locales/ja_redsurvey.json": "ac09",
	"./redsurvey/locales/ko_redsurvey.json": "ab7f",
	"./redworks/locales/en.json": "b542",
	"./redworks/locales/ja.json": "12ff",
	"./redworks/locales/ko.json": "b4a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b0f2";